import { render, staticRenderFns } from "./ContractSend.vue?vue&type=template&id=615b94da&"
import script from "./ContractSend.vue?vue&type=script&lang=js&"
export * from "./ContractSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports